import { buildQueryString } from '@izimi/utils';
class CommunicationsApi {
    fetchService;
    baseUrl = '/box/communications';
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    getCommunication(id) {
        return this.fetchService.get(`${this.baseUrl}/${id}`);
    }
    getCommunications(params) {
        const qs = buildQueryString(params);
        return this.fetchService.get(`${this.baseUrl}${qs}`);
    }
    copyCommunicationDocuments(communicationId, documentIds) {
        return this.fetchService.post(`${this.baseUrl}/${communicationId}/documents/copy`, { documents: documentIds });
    }
    async downloadCommunicationDocument(communicationId, documentId) {
        return this.fetchService.get(`${this.baseUrl}/${communicationId}/documents/${documentId}/download`, { resAsBlob: true });
    }
    createCommunication(communicationRequest) {
        return this.fetchService.post(this.baseUrl, communicationRequest);
    }
    deleteCommunications(params) {
        return this.fetchService.post(`${this.baseUrl}/delete`, params);
    }
}
export default CommunicationsApi;
